import React, {Component} from 'react'
import PropTypes from 'prop-types'
import mediumZoom from 'medium-zoom'
import LazyLoader from '../../../modules/LazyLoader.js'
import {
  getPosition,
  fixTransform
} from '../Helpers.js'

const ZOOMED_IMAGE_SELECTOR = '.image.medium-zoom-image.loaded.medium-zoom-image--opened'

export default class Gallery extends Component {

  zoom = mediumZoom()

  componentDidMount () {
    this.zoom.on('open', this.attachEvents)
    this.zoom.on('close', () => {
      this.detachEvents()
      // mobile scale image hack...
      document.querySelectorAll(ZOOMED_IMAGE_SELECTOR)[1].style.opacity = 0
    })
    this.zoom.on('opened', () => fixTransform(this.zoom, ZOOMED_IMAGE_SELECTOR))
    const lazy = new LazyLoader({
      container: document.querySelector('.content-body'),
      elements_selector: '.lazy',
      callback_load: function (el) {
        el.parentNode.style.background = 'none'
      }
    })
  }
  attachToZoom = image => {
    this.zoom.attach(image)
  }
  handleClick = e => {
    this.zoom.open({
      target: e.target.childNodes[0]
    })
  }
  nextImage = () => {
    const images = this.zoom.getImages()
    const currentImageIndex = images.indexOf(this.zoom.getZoomedImage())
    const target = currentImageIndex + 1 >= images.length ?
      images[0] : images[currentImageIndex + 1]

    this.zoom.close().then(() => {
      this.zoom.open({
        target: target
      })
    })
  }
  prevImage = () => {
    const images = this.zoom.getImages()
    const currentImageIndex = images.indexOf(this.zoom.getZoomedImage())
    const target = currentImageIndex - 1 < 0 ?
      images[images.length - 1] : images[currentImageIndex - 1]

    this.zoom.close().then(() => {
      this.zoom.open({
        target: target
      })
    })
  }
  handleKey = e => {
    switch (e.code) {
      case 'ArrowLeft':
        this.prevImage()
        break
      case 'ArrowRight':
        this.nextImage()
        break
      default:
        break
    }
  }
  handleSwipeStart = e => {
    e.preventDefault()
    const { x, y } = getPosition(e)
    this.moveStart = { x, y }
    this.clicked = true

    document.addEventListener('touchend', this.handleSwipeEnd, {passive: false})
    document.addEventListener('touchmove', this.handleSwipeMove, {passive: false})
  }
  handleSwipeMove = e => {
    e.preventDefault()
    this.clicked = false
    if (!this.moveStart) {
      return
    }
    const { x, y } = getPosition(e)
    const deltaX = x - this.moveStart.x
    const deltaY = y - this.moveStart.y
    this.moving = true

    this.movePosition = { deltaX, deltaY }
  }
  handleSwipeEnd = e => {
    const tolerance = 25
    if (this.clicked) {
      this.zoom.close()
    }
    if (this.moving && this.movePosition) {
      // if (this.movePosition.deltaY < -tolerance) {
      //   this.zoom.close()
      // } else if (this.movePosition.deltaY > tolerance) {
      //   this.zoom.close()
      // }
      if (this.movePosition.deltaX < -tolerance) {
        this.nextImage()
      } else if (this.movePosition.deltaX > tolerance) {
        this.prevImage()
      }
    }

    this.moveStart = null
    this.moving = false
    this.movePosition = null

    document.removeEventListener('touchend', this.handleSwipeEnd)
    document.removeEventListener('touchmove', this.handleSwipeMove)
  }
  onMouseDown = e => {
    this.mouseDown = true
    document.addEventListener('mouseup', this.onMouseUp);
    document.addEventListener('mousemove', this.onMouseMove);

    this.handleSwipeStart(e)
  }
  onMouseMove = e => {
    this.handleSwipeMove(e)
  }
  onMouseUp = e => {
    document.removeEventListener('mouseup', this.onMouseUp)
    document.removeEventListener('mousemove', this.onMouseMove)

    this.handleSwipeEnd(event)
  }
  attachEvents = () => {
    document.addEventListener('keyup', this.handleKey, false)
    document.addEventListener('mousedown', this.onMouseDown)
    document.addEventListener('touchstart', this.handleSwipeStart, {passive: false})
  }
  detachEvents = () => {
    document.addEventListener('touch', this.handleTouch)
    document.removeEventListener('keyup', this.handleKey, false)
    document.removeEventListener('mousedown', this.onMouseDown);
    document.removeEventListener('touchstart', this.handleSwipeStart)
  }

  renderGallery (media) {
    return (
      <div className='media-container'>
        {
          media && media.map((item, i) => {
            return (
              <div className='media' key={i} onClick={this.handleClick}>
                <figure className='image-container'>
                  <img className="lazy image"
                    src='data:image/gifbase64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw=='
                    data-src={item.thumb}
                    alt={i}
                    width={item.thumb_w}
                    height={item.thumb_h}
                    data-zoom-src={item.url}
                    data-highres-width={item.width}
                    data-highres-height={item.height}
                    draggable='false'
                    ref={this.attachToZoom}
                  />
                </figure>
              </div>
            )
          })
        }
      </div>
    )
  }
  render () {
    const {
      media,
      className
    } = this.props

    return (
      <div className={className}>
        {
          media &&
          this.renderGallery(media)
        }
      </div>
    )
  }
}

Gallery.defaultProps = {
  className: 'gallery',
  media: null
}

Gallery.propTypes = {
  className: PropTypes.string,
  media: PropTypes.oneOfType([
    PropTypes.array,
    PropTypes.object
  ])
}
